// @flow

import React from 'react';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import Erc20Icon from './erc20-icon';

export const erc20: CryptocurrencyProtocol = {
  code: 'ERC20',
  icon: <Erc20Icon alt="erc20 icon"/>,
  abbreviation: 'ERC-20',
  name: 'Ethereum (ERC-20)',
};
